import RadarChartViz from '../vizs/RadarChartViz'
import BaseComponent from './BaseComponent'


/**
 * # {componentLabel} (`class {componentClassName}`)
 * Used to display multivariate data in the form of a two-dimensional chart of three or more quantitative variables represented on axes starting from the same point.
 * 
 * ### Example Usage
 * ```javascript
 *   
 *   import {RadarChart} from 'sdv-lib'
 *   
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new RadarChart($el, data, config);
 *   
 * ```
 * 
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 3 or more columns.
 * 
 * Each row represents a line. 
 * 
 * The first columns represents the id/label of the line.
 * 
 * Each other column represents a dimension.
 * 
 * | id           |  dim1 |  dim2  |  dim3  |
 * | --------     | ------ |  ------  |  ------  |
 * |   line 1     |    22.4|      15.4|      43.2|
 * |   line 2     |    52.3|      29.3|      12.8|
 * |   line 3     |    12.8|      34.1|      61.4|
 * |   line 4     |    26.0|      12.3|      14.5|
 * 
 * {.data-table}
 * 
 * Note: All dimensions are assumed to be normalized between 0 and 100.
 * 
 *
 * */
export default class RadarChartComponent extends BaseComponent {
  static vizClass = RadarChartViz
  static componentLabel = "Radar chart"
  static dataFormat = [
    {index:0, axis:'', label:'id', types:[String], role:'id',roleLabel:'Line name'},
    {index:-1, axis:'y', label:'Dimension', types:[Number], role:'value',roleLabel: 'Dimension value'}
  ]
  static defaultConfig = {
    title: this.componentLabel,
  }
}
